define('companiesListSortHeaderView',[
  'module',
  'underscore',
  'tableHeaderFieldView'
], function (
  Module,
  _,
  HeaderFieldView
) {
  'use strict';

  // Sortable column header for the companies list. The shared table's built-in
  // column sort relies on childEvents that never fire for the (manually appended)
  // header field views, so we drive the sort directly on the table view instead.
  Module.exports = HeaderFieldView.extend({
    onSortChange: function () {
      if (!this.sort) {
        return;
      }
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      this.showSort();

      // Highlight only the active column.
      _.each(this.tableView.headerView.views, function (view) {
        if (view.enableSort) {
          view.enableSort(view === this);
        }
      }, this);

      this.tableView.setSort(this.name, this.sortDirection);
    }
  });
});

